import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campIdgReorder: FaireAdCampaignEntity = {
  token: "camp_idg_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_island_dogs",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2000,
  startedRunningAt: "2025-02-13",
  segmentMetrics: {
    numReorderConversions: 51,
    salesDollars: 18174,
    totalAdsSpendDollars: 1435,
    returnOnAdSpend: 12.66,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
